import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Layout from '@/components/Layout';
import FinancialsTab from '@/components/dashboard/FinancialsTab';
import { useSite } from '@/context/SiteContext';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export default function Financials() {
  const navigate = useNavigate();
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const { getSiteParams } = useSite();

  useEffect(() => {
    const fetchUser = async () => {
      try {
        const response = await fetch(`${BACKEND_URL}/api/auth/me`, {
          credentials: 'include'
        });
        if (!response.ok) {
          navigate('/login');
          return;
        }
        const userData = await response.json();
        
        // Allow owner (super_admin/admin — full) and service_manager + floor_manager (read-only productivity)
        if (!['super_admin', 'admin', 'service_manager', 'floor_manager'].includes(userData.role)) {
          navigate('/');
          return;
        }
        
        setUser(userData);
      } catch (error) {
        console.error('Auth error:', error);
        navigate('/login');
      } finally {
        setLoading(false);
      }
    };
    fetchUser();
  }, [navigate]);

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-slate-50">
        <div className="text-center">
          <div className="inline-block animate-spin rounded-full h-12 w-12 border-4 border-blue-600 border-t-transparent"></div>
          <p className="mt-4 text-slate-600 font-medium">Loading...</p>
        </div>
      </div>
    );
  }

  return (
    <Layout user={user}>
      <div className="p-4 md:p-6 lg:p-8" data-testid="financials-page">
        <div className="mb-6">
          <h1 className="font-bold text-3xl text-slate-900 mb-2">
            {['service_manager', 'floor_manager'].includes(user?.role) ? 'Mechanic Productivity' : 'Financials'}
          </h1>
          <p className="text-slate-500">
            {['service_manager', 'floor_manager'].includes(user?.role)
              ? 'Read-only view of mechanic productivity for the workshop'
              : 'Track income, expenses, profit & loss, and mechanic hours'}
          </p>
        </div>
        
        <FinancialsTab getSiteParams={getSiteParams} currentUser={user} />
      </div>
    </Layout>
  );
}
